import React from 'react'
import { Navbar } from 'react-bootstrap'
import NavBar from '../Components/NavBar'
import HomeContent from '../Components/HomeContent'
import HomeAllContent from '../Components/HomeAllContent'
import Footer from '../Components/Footer'
import Slider from '../Components/Slider';
import Dentin from '../Components/Dentin'
import Invisilingoffer from '../Components/Invisilingoffer'
// import InvisalignOffer from '../Components/Logo'


function Home() {
  return (
    <div>
     <HomeContent/>
     <Dentin/>
     <Invisilingoffer/>
     <HomeAllContent/>
    </div>
  )
}

export default Home
